import React from 'react';
import styled from 'styled-components';
import { Border, Color } from '../app/StyleGuide';
import WhiteLabel from '../filters/WhiteLabel';

const TrainingImageContainer = styled.div`
  display: grid;
  place-content: center;

  background: ${Color.Gray._20};
  border-radius: ${Border.radius};

  height: 102px;
  width: 212px;
  overflow: hidden;

  img {
    height: 36px;
    max-width: 128px;
  }
`;

const TrainingImageBase = ({ className }: { className?: string }) => (
  <TrainingImageContainer className={className}>
    <img alt={WhiteLabel.name} src={WhiteLabel.logoSmSrc || WhiteLabel.logoSrc} />
  </TrainingImageContainer>
);

export const TrainingImage = styled(TrainingImageBase)``;
